import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Input, FormGroup, Label, FormFeedback, Form, Spinner } from 'reactstrap';
import { Button } from '../form';
import { translate } from '../Translate';
import 'moment-duration-format';
import { FormattedMessage } from 'react-intl';

const CouponForm = ({
  values,
  isSubmitting,
  handleSubmit,
  handleChange,
  errors,
  status,
  submitCount,
  intl,
  setStatus,
  ...props
}) => {
  const deleteCoupon = () => {
    props.deleteCouponCode()
  }
  const [isInvalid, setIsInvalid] = useState(false)
  const [error, setError] = useState(false)
  useEffect(() => {
    if (errors.discountCode) {
      setIsInvalid(true);
      setError(errors.discountCode);
      setTimeout(() => { setError(false); setIsInvalid(false); }, 5000);
    } else if (status.apiErrorCode) {
      setIsInvalid(true);
      setError(status.apiErrorCode);
      setTimeout(() => { setError(false); setIsInvalid(false); setStatus({}); }, 5000);
    } else {
      setError(false);
      setIsInvalid(false);
    }
  }, [errors?.discountCode, isSubmitting]);

   useEffect(() => {    
    if (props.couponVerifyError && error !== false) {
      setIsInvalid(true);
      setError(translate(intl, `ERRORS.${props.couponVerifyError.code}.title`, {
        defaultMessage: translate(intl, 'ERRORS.SYS-ERR.title')
      }));
      props.dismissCouponError();
      setTimeout(function() { setError(false); setIsInvalid(false) }, 5000);
    }
  }, [props.couponVerifyError]);
  
  return (
    <div className="CouponCode">
      <Form onSubmit={handleSubmit}>
        <div className="CouponCode_title_container">
          <Label for="discountCode" className="CouponCode__maintitle">
            {translate(intl, 'CouponForm.form.discountCode.title')}
          </Label>
        </div>
        {props.couponApply.code &&
          <div className="CouponCode_apply_container">
            <button onClick={deleteCoupon} className="CouponCode_button">X</button>
            <Label for="discountCode" className="CouponCode__maintitle_apply">
              {translate(intl, 'CouponForm.form.discountCode.apply')}
            </Label>
            <span className="CouponCode_discountCode">{props.couponApply.code}</span>
          </div>}
        <FormGroup>
          <div style={{ display: 'flex' }}>
            <Input
              invalid={isInvalid}
              id="discountCode"
              name="discountCode"
              placeholder={translate(
                intl,
                'CouponForm.form.discountCode.placeholder'
              )}
              className="couponInput"
              value={values.discountCode}
              onChange={handleChange}
              bsSize="small"
              disabled={!!props.couponApply.code}
            />
            {error && <FormFeedback tooltip>{error}</FormFeedback>}
            <Button
              type="submit"
              className="CouponCode_button_apply"
              disabled={!!props.couponApply.code}
            >
              {
                isSubmitting
                  ? <Spinner className="CouponCode_button_spinner" />
                  : <FormattedMessage id="CouponForm.form.button.apply" />
              }
            </Button>
          </div>
        </FormGroup>
      </Form>
    </div>
  );
};

CouponForm.defaultProps = {
  errors: {},
};

CouponForm.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  submitCount: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  values: PropTypes.objectOf(PropTypes.any),
  errors: PropTypes.any,
  status: PropTypes.any,
  membership: PropTypes.any,
  intl: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    path: PropTypes.string,
    params: PropTypes.shape({
      contentId: PropTypes.string,
    }),
  }).isRequired,
  deleteCouponCode: PropTypes.func,
  couponApply: PropTypes.any,
  setStatus: PropTypes.any
};

export default CouponForm;
